// NATIVE 

// INSTALLED 
import AsyncStorage from '@react-native-async-storage/async-storage';

// CUSTOM 
import { logout, login } from './';
import { types } from '../../commons/types/types';
import { loginWithEmailPassword } from '../../services';
import { checkingPreload, unCheckingPreload } from '../loading';
import { ILoginWithEmailPassword } from '../../commons/interfaces';
import { setPermissions, setUserPermissions } from '../permissions';
import { setCompanyRedux, storeCompany } from '../company';
import { setAreasRedux } from '../areas';
import { setCargosRedux } from '../cargos';
import { setTypeDocumentRedux, storeTypeDocument } from '../type_document';
import { setPaymentMethodRedux } from '../payment_method';
import { setAssociatedBankRedux } from '../associated_bank';
import { setEpsRedux } from '../eps';
import { setFamilyCompensationRedux } from '../family_compensation_fund';
import { setCesantiasRedux } from '../severance';
import { setPensionRedux } from '../pension';
import { customerPermissionsListRedux } from '../customer';




export const startLoginWithEmailPassword = ({ email, password }:ILoginWithEmailPassword):any => {

    try {

        return async( dispatch: any  ) => {

            dispatch( checkingPreload() );
            
            

    
            const result = await  loginWithEmailPassword({ email, password });


            dispatch( unCheckingPreload() );
    

    
            if ( !result.ok ) return result;
           
            console.log('result.dataresult.data ',result.data)

            const { user, token, permissions, user_permissions, companyName } = result.data;

        
            const user_storage = {
                displayName: user.name,
                photoURL: user.avatar ?? '',
                email: user.email,
                token: token,
                errorMessage: null,
                cliente: companyName
            };

            console.log(result.data)
           

            // PERMISOS 
            await AsyncStorage.setItem(types.storage.permissionsStorage, JSON.stringify(permissions));
            await dispatch( setPermissions(permissions) );


            // PERMISOS USUARIO 
            await AsyncStorage.setItem(types.storage.userPermissionsStorage, JSON.stringify(user_permissions));
            await dispatch( setUserPermissions(user_permissions) );

            // user 
            await AsyncStorage.setItem(types.storage.userStorage, JSON.stringify(user_storage));
            await dispatch( login( user_storage ));

  

            dispatch( unCheckingPreload() );
            
        }
        
    } catch (error) {
        console.log('conooooooooooooooooooooooooooooooooooo ', error)
    }
}


export const startLogOut = (): any => {


    try {

        return async( dispatch: any  ) => {

            dispatch( checkingPreload() );
                await AsyncStorage.removeItem(types.storage.userStorage);
                await AsyncStorage.removeItem(types.storage.permissionsStorage);
                await AsyncStorage.removeItem(types.storage.userPermissionsStorage);
                
                
                dispatch( logout() );
            dispatch( unCheckingPreload() );
    
        }
        
    } catch (error) {
        console.log('conooooooooooooooooooooooooooooooooooo ', error);
    }

}